






















































































































































import merge from 'lodash/merge';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { PriceListListPageQuery } from './queries/_build_documents_list';
import { ServerResult } from '../../../core/http/server_result';
import ClientPriceElementForm from '../../ClientPriceElementForm/ClientPriceElementForm.vue';
import select from "buefy/src/components/select/Select.vue";

export const ITEMS_LIST = 'ITEMS_LIST';

@Component({
  computed: {
    select() {
      return select
    }
  }
})
export default class ClientPriceList extends Vue {

  @Prop() clientId!: string;

  tableParams = {};
  documents = [];
  loading = false;
  lastMeta = {};

  selectedView: string = 'active'

  get defaultSort() {
    return [this.$route.query.sortField || 'hidden', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    // tableParams
    this.tableParams = merge(this.tableParams, {
      sortField: field, sortDirection: direction
    })

    this.loadData();
  }


  private delayFilter: any = null
  private delayFilterValue: any = null

  onSearch(filter: string, value: any) {
    this.tableParams = merge(this.tableParams, {
      [filter]: value
    });
    if (!this.delayFilter) {
      setTimeout(() => {
        this.delayFilter = null
        this.loadData();
      }, 3000)
    }
    this.delayFilter = filter
    // this.delayFilterValue = value
  }

  onSelectView($event: any) {
    this.selectedView = $event;
    this.loadData();
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.tableParams = merge(this.tableParams, {
      page
    });

    this.loadData();
  }

  loadData() {
    this.loading = true;
    const _filters: any = {...this.tableParams}
    if (this.selectedView !== 'all') {
      _filters['view'] = this.selectedView
    }
    console.log(_filters);

    (this as any).$db([
      (this as any).$q(ITEMS_LIST)
        .raw('documents.list')
        .action(PriceListListPageQuery.build({
          ..._filters,
          clientId: this.clientId
        }))
    ]).then((result: ServerResult) => {
      console.log(result.getOperation(ITEMS_LIST).getContent())
      const opResult = result.getOperation(ITEMS_LIST).getContent()

      this.documents = opResult.documents;
      this.lastMeta = opResult.meta;
    }).finally(() => {
      this.loading = false;
    });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any, isNew: boolean = false) {
    this.$buefy.modal.open({
      component: ClientPriceElementForm,
      props: {
        isNew,
        documentPreview: row,
        initParams: {
          client_id: this.clientId,
          container_price: 0
        }
      },
      events: {
        'form-close': () => {
          this.loadData();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }

  // ---------------------------------------------------------------------------

  mounted() {
    this.loadData();
  }
}

